import { useEffect, useState } from 'react';

/**
 * Hook to detect if the current viewport is mobile-sized
 * @returns boolean indicating whether the viewport is mobile-sized (width <= 1100px)
 */
export const useIsMobile = (): boolean => {
  const [isMobile, setIsMobile] = useState<boolean>(false);

  useEffect(() => {
    const handleResize = (): void => {
      setIsMobile(window.innerWidth < 1024);
    };

    handleResize();

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  return isMobile;
};
